// src/pages/sales/SalesRedirect.jsx
import React from "react";
import { Navigate } from "react-router-dom";


export default function SalesRedirect() {
  const user = JSON.parse(localStorage.getItem("user") || "null");

  if (!user) return <Navigate to="/login" replace />;

  const roleName = (user.roleName || "").toLowerCase();

  if (roleName.includes("admin")) {
    return <Navigate to="/sales/admin-view" replace />;
  }

  if (roleName.includes("sales")) {
    return <Navigate to="/sales/my-view" replace />;
  }

  // fallback
  return <Navigate to="/" replace />;
}
